export const normalizeFlyerInstanceId = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "")
    .slice(0, 32);

const FLYER_INSTANCE_ID_LENGTH = 6;
const FLYER_INSTANCE_ID_SPACE = 36 ** FLYER_INSTANCE_ID_LENGTH;
const UINT32_SPACE = 2 ** 32;
const UINT32_REJECTION_LIMIT =
  Math.floor(UINT32_SPACE / FLYER_INSTANCE_ID_SPACE) * FLYER_INSTANCE_ID_SPACE;

export const createFlyerInstanceId = () => {
  let value = null;

  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint32Array(1);
    do {
      crypto.getRandomValues(bytes);
    } while (bytes[0] >= UINT32_REJECTION_LIMIT);
    value = bytes[0] % FLYER_INSTANCE_ID_SPACE;
  } else {
    value = Math.floor(Math.random() * FLYER_INSTANCE_ID_SPACE);
  }

  return normalizeFlyerInstanceId(
    Number(value).toString(36).padStart(FLYER_INSTANCE_ID_LENGTH, "0"),
  );
};
